/**
 * It takes a number and returns a string with the number formatted as a price
 * @param price - The price to format.
 * @returns The price is being formatted to a number with commas.
 */
export const formatPrice = (price: number) => {
  const formatted = new Intl.NumberFormat('en-US').format(price | 0);
  return formatted;
};
